import React from "react";
// Files Import
import StyledMdText from "../../common/components/styledMdText/StyledMdText";
import StyledXlText from "../../common/components/styledXlText/StyledXlText";

export default function AccordionBox({ data, activeElement, index }) {

    return (
        <div className="w-full text-white">
            <div>
                <button className="w-full text-left focus:outline-none">
                    <div
                        className={`flex justify-between items-center `}
                    >
                        <StyledXlText fontColor="text-gradient">{data.question}</StyledXlText>
                        {/* Arrow  icon */}
                        {
                            activeElement === index ? (
                                <img src="/assets/images/minus.webp" alt="Minus Icon" />
                            ) : (
                                <img src="/assets/images/plus.webp" alt="Minus Icon" />
                            )
                        }
                    </div>
                </button>
            </div>
            <div
                style={{
                    maxHeight: activeElement === index ? "1000px" : "0",
                    paddingTop: activeElement === index ? "1rem" : "0",
                    height: activeElement === index ? "max-content" : "0",
                    overflow: "hidden",
                    transition: "max-height 2.7s ease",
                }}
            >
                <StyledMdText fontColor="text-white" children={data.answer} />
            </div>
        </div>
    );
}